:host {
  display: block;
}

.container-view {
  display: flex;
  justify-content: flex-start;
  padding: 22px 0 22px;
  border-bottom:  1px solid var(--color-lighter-gray);
}

a {
  text-decoration: none;
  color: var(--color-link-blue);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  background-color: transparent;
}
a:hover {
  text-decoration: underline;
  color:  var(--color-cwru-blue);
}

p {
  margin: var(--s-1) 0;
}

.image-view {
  max-width:  176px;
  height:  210px;
  display: block;
}

.bio-image-container-view {
/*  flex-grow: 2;*/
  margin-right:  20px;
  /*float: left;*/
  /*position: relative;
  max-width:  176px;*/
}

.bio-body-view {
  /*flex-grow: 3;*/
  display: table-cell;
  vertical-align: top;
}
.name-creds-view {
  margin: 0;
  font-size: var(--s1);
}

@media (max-width: 55rem) {
  .container-view {
    flex-direction: column;
  }
  .image-view {
    margin-bottom: 22px;
  }
}


/***** Biography Full *****/

.bio-aside {
  border: 1px solid #c6c6c6;
  padding: 12px;
  margin-left: 22px;
  margin-bottom: 22px;
  word-break: break-all;
  font-size: var(--s0);
  max-width: 276px;
  float: right !important;
  position: relative;
  display: block;
}

.image-bio-full {
  height: auto;
  display: block;
  margin-bottom: 12px;
  max-width:  276px;
}

.bio-aside-label {
  font-weight: var(--font-weight-semibold);
  word-break: break-all;
}

.bio-full-name h1 {
  line-height: var(--s2);
}
